import { BenefitItem, CTAContent } from './types';

export const css = `
  .cta-section {
    background: linear-gradient(135deg, var(--c-primary-6), var(--c-primary-7));
    color: var(--c-neutral-0);

    h2 {
      color: inherit;
    }

    .benefit-icon,
    .benefit-item {
      background: color-mix(in oklch, var(--c-primary-5) 50%, transparent)
    }

    .cta-button {
      background: var(--c-primary-0);
      color: var(--c-primary-7);

      &:hover {
        background: var(--c-primary-1);
      }
    }
  }
`;

// Updated BenefitItem component
function BenefitItem({ data }: { data: BenefitItem }) {
  return (
    <div class="benefit-item rounded-xl p-8 hover:-translate-y-1.5 transition-all pb-10">
      <div class="benefit-icon size-20 mx-auto mb-6 rounded-full flex items-center justify-center text-2xl shadow-2xl">
        {data.icon}
      </div>
      <h3 class="text-xl font-bold mb-4">{data.title}</h3>
      <p class="opacity-80 leading-relaxed text-base">{data.description}</p>
    </div>
  );
}

// Updated CTA component
export function View({ data }: { data: CTAContent }) {
  return (
    <section id="discovery" class="cta-section py-24 relative">
      <div class="max-w-7xl mx-auto px-8 text-center relative z-10">
        <h2 class="text-4xl font-bold mb-16">{data.title}</h2>

        <div class="grid md:grid-cols-3 gap-10 max-w-5xl mx-auto">
          {data.benefits.map((benefit) => (
            <BenefitItem key={benefit.id} data={benefit} />
          ))}
        </div>

        <div class="mt-16 flex flex-col items-center gap-4">
          <p class="text-lg font-medium mb-6 relative inline-block">
            {data.callToAction.guarantee}
          </p>

          <a
            href={data.callToAction.button.href}
            class="cta-button inline-flex items-center px-9 py-4 rounded-lg font-semibold text-lg hover:-translate-y-1 transition-all shadow-lg mb-5 bg-gray-100 gap-4"
          >
            <span>{data.callToAction.button.icon}</span> {data.callToAction.button.text}
          </a>

          <p class="italic">{data.callToAction.availability}</p>
        </div>
      </div>
    </section>
  );
}
